//@vendors
const Immutable = require('immutable');
const { handleActions, combineActions } = require('redux-actions');
const get = require('lodash/object/get');
const find = require('lodash/collection/find');
// @core
const { formatText } = require('core/i18n').i18n;
//@actions
const { simpleActions } = require('../../actions/payrollLoanRequest');
// @ utilities
const { scrollToTop } = require('commonsUtilities/scrollUtils');
//@constants
const {
    SECOND_STEP,
    WIZARD_SECOND_STEP,
    EURO_TEXT
} = require('constants/index');
const {
    contractEasyLoan: { PAYMENT_DAY_OTHER },
    payrollLoanRecordStatus: { requestStatus: { KOxDTI, ERROR_DOCUMENTACION }, contractStatus: { NUEVA_OFERTA } },
    payrollLoanErrorDocument: { NOM_VL, IRPF100, PEND_VAL, NO_VALIDO },
    payrollLoanTypeUpload: { FILE_FIRST_INDEX },
    payrollLoanLayoutKOxDTI: {
        MIN_TERM,
        MAX_AMOUNT,
        MAX_TERM,
        MAX_AMOUNT_COLLECTIVE
    },
    payrollLoanJobs: {
        PAYROLL_LOAN_JOB_PERMANENT_EMPLOYEE,
        PAYROLL_LOAN_JOB_PENSIONER,
        PAYROLL_LOAN_JOB_AUTONOMOUS,
        PAYROLL_LOAN_JOB_OTHER
    },
    payrollLoanTypeUpload: {
        IRPF_FILE,
        PAYROLL_LOAN_CERTIFICATE,
        ADITIONAL_EXPENSES_FILES
    },
    payrollLoanJobTypeKeys: {
        OWN_ACCOUNT_DRAGO_OPTION_KEY
    },
    MAX_UPLOAD_EXPENSES_COMPONENTS
} = require('../../loansConstants/index');
//@utilities
const {
    getEnableDocumentsFlowFlag,
    getIsKOxDTI,
    getTranslatedDocumentName,
    showWorkingTimeSection,
} = require('../../loansUtilities/loansHelper');

const setInitialState = () => Immutable.fromJS({
    cardDeniedVisible: true,
    collectiveInformation: [{
        name: '',
        code: '',
        productDetail: {
            type: '',
            subType: '',
            standardCode: ''
        },
        installment: {
            amount: 0,
            currency: EURO_TEXT
        },
        KOxDTI: {
            seletedAmountOrTerm: false
        },
        outcome: {
            rent: 0,
            mortgage: 0,
            others: 0
        },
        processType: "loanContracting",
        proposition: {
            isFetching: false,
            success: false
        },
        steps: [
            {},
            { valid: false },
            { valid: __CONTACT_CENTER__ },
            { valid: false, hasSignaturePattern: true }
        ],
        upload: {
            isLoadingFiles: false,
            [IRPF_FILE]: {
                isFetching: false,
                uploaded: false,
                loaded: false,
                error: '',
                notValid: false,
                file: {}
            },
            [PAYROLL_LOAN_CERTIFICATE]: {
                isFetching: false,
                uploaded: false,
                loaded: false,
                error: '',
                notValid: false,
                file: {}
            },
            [ADITIONAL_EXPENSES_FILES]: {
                error: '',
                files: [
                    {
                        isFetching: false,
                        uploaded: false,
                        loaded: false,
                        error: '',
                        idx: 0,
                        file: {}
                    },
                ]
            },
            payrollLoanDocumentsState: {},
            isFetching: false,
            isFetchingDocumentsConfirm: false,
            error: ''
        },
        callServicePreApproval: false,
        enableDocumentsFlow: false,
        error: false,
        errorAsnef: false,
        isCallingSaveInProgress: false,
        isFetching: false,
        isFetchingAsnef: false,
        isFetchingLoans: true,
        isFetchingKOxDTI: false,
        isFetchingInstallment: false,
        rejected: false,
        simulationToken: '',
        stepCallPreApproval: SECOND_STEP,
        submitSuccessful: false,
        visibleStep: 1,
        willCancel: false,
        arrangementFee: 0,
        arrangementMin: 0,
        arrangementPercentage: 0,
        civilStatus: null,
        companyMonths: null,
        companyYears: null,
        creditCards: null,
        currency: EURO_TEXT,
        expirationDate: '',
        initialized: false,
        isCollective: false,
        isFetchingMaxImport: false,
        isFetchingMinTerm: false,
        isFetchingValidateAmountKOxDTI: false,
        job: PAYROLL_LOAN_JOB_PERMANENT_EMPLOYEE,
        lowerKOxDTI: false,
        loans: [],
        maxAmount: 0,
        maxTerm: 0,
        minAmount: 0,
        minTerm: 0,
        pages: [],
        paymentDaySelected: PAYMENT_DAY_OTHER, // Fixed Value: Anniversary date
        preApprovalState: '',
        productStandard: '',
        productSubType: '',
        productType: '',
        recordId: '', //expedient id
        regime: null,
        secondCallInitilized: false,
        selectedAmount: 0,
        selectedPurpose: '',
        selectedPurposeDrago: '',
        selectedTerm: 0,
        tae: 0,
        tin: 0,
        tae: 0,
        totalAmount: 0
    }],
    income: {
        amount: 0,
        extra: '0'
    },
    installment: {
        amount: 0,
        currency: EURO_TEXT
    },
    KOxDTI: {
        seletedAmountOrTerm: false
    },
    outcome: {
        rent: 0,
        mortgage: 0,
        others: 0
    },
    processType: "loanContracting",
    proposition: {
        isFetching: false,
        success: false
    },
    steps: [
        {},
        { valid: false },
        { valid: __CONTACT_CENTER__ },
        { valid: false, hasSignaturePattern: true }
    ],
    newSteps: [
        {},
        { valid: false },
        { valid: false },
        { valid: __CONTACT_CENTER__ },
        { valid: false, hasSignaturePattern: true }
    ],
    upload: {
        isLoadingFiles: false,
        [IRPF_FILE]: {
            isFetching: false,
            uploaded: false,
            loaded: false,
            error: '',
            notValid: false,
            file: {}
        },
        [PAYROLL_LOAN_CERTIFICATE]: {
            isFetching: false,
            uploaded: false,
            loaded: false,
            error: '',
            notValid: false,
            file: {}
        },
        [ADITIONAL_EXPENSES_FILES]: {
            error: '',
            files: [
                {
                    isFetching: false,
                    uploaded: false,
                    loaded: false,
                    error: '',
                    idx: 0,
                    file: {}
                },
            ]
        },
        payrollLoanDocumentsState: {},
        isFetching: false,
        isFetchingDocumentsConfirm: false,
        error: ''
    },
    callServicePreApproval: false,
    enableDocumentsFlow: false,
    error: false,
    isCallingSaveInProgress: false,
    isFetching: false,
    isFetchingLoans: true,
    isFetchingKOxDTI: false,
    isFetchingInstallment: false,
    rejected: false,
    simulationToken: '',
    stepCallPreApproval: SECOND_STEP,
    submitSuccessful: false,
    visibleStep: 1,
    willCancel: false,
    arrangementFee: 0,
    arrangementMin: 0,
    arrangementPercentage: 0,
    civilStatus: null,
    companyMonths: null,
    companyYears: null,
    creditCards: null,
    currency: EURO_TEXT,
    expirationDate: '',
    initialized: false,
    isCollective: false,
    isFetchingMaxImport: false,
    isFetchingMinTerm: false,
    isFetchingValidateAmountKOxDTI: false,
    job: PAYROLL_LOAN_JOB_PERMANENT_EMPLOYEE,
    lowerKOxDTI: false,
    loans: [],
    maxAmount: 0,
    maxTerm: 0,
    minAmount: 0,
    minTerm: 0,
    pages: [],
    paymentDaySelected: PAYMENT_DAY_OTHER, // Fixed Value: Anniversary date
    preApprovalState: '',
    productStandard: '',
    productSubType: '',
    productType: '',
    recordId: '', //expedient id
    regime: null,
    secondCallInitilized: false,
    selectedAmount: 0,
    selectedPurpose: '',
    selectedPurposeDrago: '',
    selectedTerm: 0,
    tae: 0,
    tin: 0,
    totalAmount: 0,
    userType: '',
    validate: false,
    viewLayoutPreApprovalKOxDTI: false,
    checkboxCirbe: false,
    isPrecontractualEmailIsFetiching: false,
    isPrecontractualEmailSent: false,
    isPrecontractualEmailError: false,
    isFetchingPrecontractualDocuments: false,
    isFetchingPrintDocuments: false,
    isEasyLoanEmailSent: false,
    isFetchingNewJobTypes: false,
    newJobTypesList: [],
    newJobType: null,
    employmentLevelList: [],
    employmentLevel: null,
    contractTypeList: [],
    contractType: null,
    totalSenorityFieldsIsDirty: false,
    senorityFieldsIsDirty: false,
    totalSenorityYears: null,
    totalSenorityMonths: null,
    isFetchingNewPurposes: false,
    monthsWorkingTime: null,
    yearsWorkingTime: null,
    newPurposesList: [],
    isFetchingPersonalData: false,
    maritalStatusList: [],
    maritalStatusDrago: null,
    housingRegimeList: [],
    housingTypeDrago: null,
    subpurposeList: [],
    subpurposeDrago: null,
    scrollDown: false,
    agreeIneCheckbox: false,
    isFetchingDocuments: true,
    isPayrollLoanEmailSent: false,
    isPayrollLoanEmailError: false,
    changePayrollStatus: false,
    changeStatusINE: false,
    changeStatusSimpleEmail: false,
    checkboxFlag: false,
    expedientOperationProcessId: false,
    filePayrollLoanINEDocumentSuccess: false,
    payrollLoanRequestShowRadioButtons: null,
    payrollLoanRequestPrintedDocument: null,
    errorCode: null,
});

const validateJobInformationDrago = (state, isDragoFeature) => {
    let jobError;
    if (!isDragoFeature) {
        const job = state.get('job');
        jobError = (job !== PAYROLL_LOAN_JOB_PENSIONER) &&
            (job !== PAYROLL_LOAN_JOB_AUTONOMOUS) && job !== (PAYROLL_LOAN_JOB_OTHER);
    } else {
        const jobTypeDrago = state.get('newJobType');
        const jobLevelDrago = state.get('employmentLevel');
        const contractTypeDrago = state.get('contractType');

        if (jobTypeDrago) {
            const newJobTypesList = state.get('newJobTypesList');
            const newJobType = newJobTypesList.find(newJobType => jobTypeDrago === newJobType.get('value'));
            const thereAreJobLevel = newJobType.get('jobLevel').find(jobLevel => jobLevel.get('visible'));
            if (thereAreJobLevel) {
                if (jobLevelDrago) {
                    const employmentLevelList = typeof state.get('employmentLevelList').toJS !== 'undefined' ?
                        state.get('employmentLevelList').toJS() : state.get('employmentLevelList');
                    const employmentLevel = employmentLevelList.find(employmentLevel => jobLevelDrago === employmentLevel.value);
                    const contractTypeList = employmentLevel.contractType && typeof employmentLevel.contractType.toJS !== 'undefined' ? employmentLevel.contractType.toJS() : employmentLevel.contractType
                    const thereAreContractType = contractTypeList.some(contractType => contractType.visible);
                    if (thereAreContractType) {
                        jobError = !contractTypeDrago;
                    } else {
                        jobError = false;
                    }
                } else {
                    jobError = true;
                }
            } else {
                jobError = false;
            }
        } else {
            jobError = true;
        }
    }
    return jobError;
}

const splitPayrollLoan = (payrollLoanData) => {
    return typeof payrollLoanData === "string" ? parseInt(payrollLoanData.split(' ')[0]) : payrollLoanData;
}

const validateErrorWorkingTimeDrago = (state, isDragoFeature) => {
    const companyYears = splitPayrollLoan(state.get('companyYears'));
    const companyMonths = splitPayrollLoan(state.get('companyMonths'));
    const actualTimeError = !(companyMonths || companyMonths === 0) && !(companyYears || companyYears === 0);

    let totalTimeError = false;
    if (!isDragoFeature) {
        return actualTimeError;
    } else {
        if (state.get('newJobType') !== OWN_ACCOUNT_DRAGO_OPTION_KEY) {
            const totalSenorityYears = splitPayrollLoan(state.get('totalSenorityYears'));
            const totalSenorityMonths = splitPayrollLoan(state.get('totalSenorityMonths'));
            totalTimeError = !totalSenorityMonths && !totalSenorityYears;
            if (!totalTimeError) {
                if (totalSenorityYears < state.get('companyYears')) {
                    totalTimeError = true;
                } else if (totalSenorityYears === companyYears && totalSenorityMonths < companyMonths) {
                    totalTimeError = true;
                }
            }
        }
    }
    return actualTimeError || totalTimeError;
}

const validateStepTwo = (state, values, isDragoFeature = false, newSteps) => {
    const creditCardsError = !state.get('creditCards') && state.get('creditCards') !== 0;
    const steps = newSteps ? 'newSteps' : 'steps'

    const civilStatusError = isDragoFeature ? !state.get('maritalStatusDrago') : !state.get('civilStatus');
    const regimeError = isDragoFeature ? !state.get('housingTypeDrago') : !state.get('regime');
    const subpurposeDragoError = state.get('subpurposeList').size > 0 && !state.get('subpurposeDrago')
    const purposeError = isDragoFeature ? !state.get('selectedPurposeDrago') || subpurposeDragoError : !state.get('selectedPurpose');

    const jobError = validateJobInformationDrago(state, isDragoFeature);

    const amount = state.getIn(['income', 'amount']);
    const incomeError = amount === '' || amount === 0;

    let seniorityError;
    if (isDragoFeature) {
        seniorityError = showWorkingTimeSection(state.get('newJobType')) ?
            validateErrorWorkingTimeDrago(state, isDragoFeature) : jobError;
    } else {
        const yearsWorkingTime = state.get('yearsWorkingTime');
        const monthsWorkingTime = state.get('monthsWorkingTime');
        seniorityError = !yearsWorkingTime && !monthsWorkingTime && jobError;
    }

    const valid = !(seniorityError || purposeError || incomeError ||
        regimeError || civilStatusError || creditCardsError || jobError);
    const visibleStep = valid ? WIZARD_SECOND_STEP + 1 : WIZARD_SECOND_STEP;

    if (!valid) {
        scrollToTop();
    }

    return state.setIn([steps, SECOND_STEP, 'valid'], valid)
        .mergeDeep({
            visibleStep: visibleStep,
            valid: valid,
            validate: true,
            ...values
        });
};

const processJob = (state, selectedJob) => {
    let partialState = state.set('job', selectedJob);

    const jobsWithoutSeniority = [
        PAYROLL_LOAN_JOB_PENSIONER,
        PAYROLL_LOAN_JOB_AUTONOMOUS,
        PAYROLL_LOAN_JOB_OTHER
    ];

    if (jobsWithoutSeniority.includes(selectedJob)) {
        partialState = partialState.mergeDeep({
            infoFirstStep: {
                companyMonths: null,
                companyYears: null
            }
        });
    }

    return partialState;
};

const mapInitilialize = (state, response, fourFlow) => {
    const secondCall = state.get('secondCallInitilized');
    const preApprovalState = secondCall ?
        state.get('preApprovalState') : get(response, 'loanRecordInformation.status', '');

    const yearsPlaceholder = formatText("payrollLoanRequestStepOne-payrollLoanRequestStepOne_workingTimeYearsPlaceholder").split(' ')[1];
    const monthsPlaceholder = formatText("payrollLoanRequestStepOne-payrollLoanRequestStepOne_workingTimeMonthsPlaceholder").split(' ')[1];


    let companyMonths = get(response, 'financialInformation.jobSeniorityInMonths');
    let companyYears = get(response, 'financialInformation.jobSeniorityInYears');
    let totalSenorityMonths = get(response, 'financialInformation.totalJobInMonths');
    let totalSenorityYears = get(response, 'financialInformation.totalJobInYears');

    companyMonths = (companyMonths || companyMonths === 0) ? `${companyMonths} ${monthsPlaceholder}` : null;
    companyYears = (companyYears || companyYears === 0) ? `${companyYears} ${yearsPlaceholder}` : null;
    totalSenorityMonths = (totalSenorityMonths || totalSenorityMonths === 0) ? `${totalSenorityMonths} ${monthsPlaceholder}` : null;
    totalSenorityYears = (totalSenorityYears || totalSenorityYears === 0) ? `${totalSenorityYears} ${yearsPlaceholder}` : null;

    return {
        arrangementFee: get(response, 'loanRecordInformation.commission') || 0,
        arrangementPercentage: get(response, 'loanRecordInformation.commissionPercentage') || 0,
        cardDeniedVisible: get(response, 'loanRecordInformation.cardVisible') || true,
        initialized: true,
        isFetching: false,
        installment: { amount: get(response, 'installment') || 0 },
        maxAmount: get(response, 'loanProductInformation.maxAmount') || 0,
        maxTerm: get(response, 'loanProductInformation.maxTerm') || 0,
        minAmount: get(response, 'loanProductInformation.minAmount') || 0,
        minTerm: get(response, 'loanProductInformation.minTerm') || 0,
        maxInstallment: get(response, 'loanRecordInformation.maxInstallment') || 0,
        selectedTerm: get(response, 'loanRecordInformation.term') || 0,
        selectedAmount: get(response, 'loanRecordInformation.amount') || 0,
        productSubType: get(response, 'loanRecordInformation.productSubType') || 0,
        productType: get(response, 'loanRecordInformation.productType', ''),
        recordId: get(response, 'loanRecordInformation.recordId', ''),
        productStandard: get(response, 'loanRecordInformation.currentDateReferenceStandard', ''),
        endOfMonthReferenceStandard: get(response, 'loanRecordInformation.endOfMonthReferenceStandard', ''),
        tae: get(response, 'tae') || 0,
        tin: get(response, 'loanRecordInformation.tin') || 0,
        totalAmount: get(response, 'totalAmount') || 0,
        selectedPurpose: get(response, 'loanRecordInformation.purpose', ''),
        selectedPurposeDrago: get(response, 'loanRecordInformation.purposeDrago', ''),
        subpurposeDrago: get(response, 'loanRecordInformation.subPurposeDrago', ''),
        preApprovalState,
        job: get(response, 'financialInformation.jobType', PAYROLL_LOAN_JOB_PERMANENT_EMPLOYEE),
        companyMonths,
        companyYears,
        regime: get(response, 'financialInformation.housingType', ''),
        civilStatus: get(response, 'financialInformation.maritalStatus', ''),
        userType: get(response, 'loanRecordInformation.userType'),
        income: {
            amount: get(response, 'financialInformation.netIncome') || 0,
            extra: (get(response, 'financialInformation.additionalPayments') || 0).toString()
        },
        outcome: {
            rent: get(response, 'financialInformation.rent') || 0,
            mortgage: get(response, 'financialInformation.mortgageFee') || 0,
            others: get(response, 'financialInformation.otherLoanInstallments') || 0,
        },
        creditCards: get(response, 'financialInformation.numberOfCreditCards', null),
        showNewOfferView: preApprovalState === NUEVA_OFERTA,
        viewLayoutPreApprovalKOxDTI: preApprovalState === KOxDTI,
        enableDocumentsFlow: (!fourFlow && !secondCall) ? getEnableDocumentsFlowFlag(preApprovalState) : false,
        collectiveInformation: get(response, 'collectiveInformation', []),
        secondCallInitilized: false,
        checkboxCirbe: false,
        totalSenorityYears,
        totalSenorityMonths,
        newJobType: get(response, 'financialInformation.jobTypeDrago', null),
        employmentLevel: get(response, 'financialInformation.jobLevelDrago', null),
        contractType: get(response, 'financialInformation.contractTypeDrago', null),
        maritalStatusDrago: get(response, 'financialInformation.maritalStatusDrago', null),
        housingTypeDrago: get(response, 'financialInformation.housingTypeDrago', null),
        yearsWorkingTime: get(response, 'financialInformation.totalJobInYears'),
        monthsWorkingTime: get(response, 'financialInformation.totalJobInMonths'),
    }
};

const mapInstallment = (response) => {
    const normal = get(response, 'installmentTae.installmentTae', {});
    const collective = get(response, 'installmentTaeCollective.installmentTae');

    const mapTae = (data) => ({
        tae: get(data, 'tae', 0),
        indIntccp: get(data, 'indIntccp', ''),
        indCapson: get(data, 'indCapson', '')
    });

    const result = {
        isFetchingInstallment: false,
        totalAmount: get(response, 'installmentTae.totalAmount', 0),
        installment: {
            amount: get(normal, 'importePriCuota.importe'),
            currency: get(normal, 'importePriCuota.divisa')
        },
        ...mapTae(normal),
    };

    if (collective) {
        result.collectiveInformation = [{
            totalAmount: get(response, 'installmentTaeCollective.totalAmount', 0),
            collectiveName: get(response, 'installmentTaeCollective.collectiveName', 0),
            installment: get(collective, 'importePriCuota.importe'),
            ...mapTae(collective),
        }];
    }

    return result;
};

const validateOfferKOxDTI = (state, action) => {
    const { minTerm } = get(action, 'payload.response');
    const maxAmount = state.get('maxAmount');
    const selectedAmount = state.get('selectedAmount');
    const lower = maxAmount < selectedAmount;

    return state.mergeDeep({
        isFetchingValidateAmountKOxDTI: false,
        lowerKOxDTI: lower,
        maxAmount,
        selectedAmount: lower ? maxAmount : selectedAmount,
        minTerm: minTerm > MAX_TERM ? MAX_TERM : minTerm,
        selectedTerm: MAX_TERM
    });
};

const mapMinTerm = (action) => {
    const minTerm = action.payload.response.minTerm > MAX_TERM ?
        MAX_TERM : action.payload.response.minTerm;

    return {
        isFetchingMinTerm: false,
        minTerm
    };
};

const mapLoanApprovedInfo = (state, response) => {
    const isCollective = state.get('isCollective');
    const preApprovalStatus = response.preApprovalStatus || '';
    let selectedAmount = state.get('selectedAmount');
    let maxAmount;

    if (getIsKOxDTI(preApprovalStatus)) {

        if (isCollective && selectedAmount > MAX_AMOUNT_COLLECTIVE) {
            selectedAmount = MAX_AMOUNT_COLLECTIVE;
        } else {
            selectedAmount = response.maxAmount > MAX_AMOUNT ? MAX_AMOUNT : response.maxAmount;
        }
    }

    if (isCollective && response.maxAmount > MAX_AMOUNT_COLLECTIVE) {
        maxAmount = MAX_AMOUNT_COLLECTIVE;
    }
    else {
        maxAmount = response.maxAmount > MAX_AMOUNT ? MAX_AMOUNT : response.maxAmount;
    }

    const newState = {
        productType: response.productType || '',
        productSubType: response.productSubType || '',
        productStandard: response.referenceStandard || '',
        preApprovalState: response.preApprovalStatus || '',
        maxInstallment: response.maxInstallment || state.get('maxInstallment'),
        maxAmount,
        selectedAmount,
        totalAmount: response.newTotalAmount || 0,
        expirationDate: response.expirationDate || '',
        installment: {
            amount: response.newInstallment || 0
        },
        isFetching: false
    };

    if (isCollective) {
        newState.collectiveInformation = [{
            tin: response.tin || 0,
            tae: response.newTae || 0,
            installment: response.newInstallment || 0
        }];
    } else {
        newState.tin = response.tin || 0;
        newState.tae = response.newTae || 0;
    }

    return state.mergeDeep(newState);
};

const processPropositionResponse = (state, response) => {
    return state.mergeDeep({
        proposition: {
            fechaFinCarencia: response.fechaFinCarencia,
            fechaAmortiz: response.fechaAmortiz,
            vencDate: response.vencDate,
            contractNumber: response.contractNumber,
            propositionNumber: response.propositionNumber,
            propositionYear: response.propositionYear,
            isFetching: false,
            success: true
        }
    });
};

const changeViewKOxDTI = (state, action) => {
    const setValues = {
        stepCallPreApproval: state.get('visibleStep'),
        visibleStep: action.payload.response.visibleStep,
        isFetchingKOxDTI: false,
        KOxDTI: {
            seletedAmountOrTerm: false
        },
        viewLayoutPreApprovalKOxDTI: action.payload.response.viewLayoutPreApprovalKOxDTI
    }
    return validateStepTwo(state, setValues, action.payload.isDragoFeature);
};

const convertTypeFile = (uploadName) => {
    let documentType;
    if (uploadName === PAYROLL_LOAN_CERTIFICATE) {
        documentType = NOM_VL;
    } else {
        documentType = IRPF100;
    }
    return documentType;
}

const clearFileStatus = (state, uploadName) => {
    let associatedDocuments = state.getIn(['upload', 'payrollLoanDocumentsState', 'associatedDocuments']);
    if (associatedDocuments) {
        associatedDocuments = associatedDocuments.map(item => {
            if (item.get('documentType') === convertTypeFile(uploadName)) {
                item = item.set('documentState', '');
            }
            return item;
        });
    }
    return state.setIn(['upload', 'payrollLoanDocumentsState', 'associatedDocuments'], associatedDocuments);
}

const removeFile = (state, config, uploadName, idx) => {
    state = clearFileStatus(state, uploadName);
    if (uploadName === ADITIONAL_EXPENSES_FILES) {
        let files = state.getIn(['upload', ADITIONAL_EXPENSES_FILES, 'files']);
        files = files.filter(file => file.get('idx') !== idx);

        const lastcard = files.get(files.size - 1);
        if (!!lastcard.get('loaded')) {
            const newConfig = Object.assign({}, config, { idx: lastcard.get('idx') + 1 });
            files = files.concat([Immutable.fromJS(newConfig)]);
        }

        state = state.setIn(['upload', 'isLoadingFiles'], false);
        return state.setIn(['upload', uploadName, 'files'], files);
    } else {
        return state.mergeDeep({
            upload: {
                isLoadingFiles: false,
                [uploadName]: config
            }
        });
    }
}

const clearErrors = (state, uploadName, idx) => {
    state = clearFileStatus(state, uploadName);
    if (uploadName === ADITIONAL_EXPENSES_FILES) {
        let files = state.getIn(['upload', ADITIONAL_EXPENSES_FILES, 'files']);
        const index = files.findIndex(immfile => immfile.get('idx') === idx);

        if (index === -1) {
            return state;
        }

        let newFile = files.get(index);
        const previousFileState = files.getIn([index, 'previousFileState']);
        if (previousFileState) {
            newFile = previousFileState;
        }
        newFile = newFile.merge({
            error: '',
            isFetching: false
        });

        return state.setIn(['upload', ADITIONAL_EXPENSES_FILES, 'files', index], newFile);

    } else {
        const config = Immutable.fromJS({
            isFetching: false,
            file: {},
            loaded: false,
            error: '',
            notValid: false
        });
        return state.setIn(['upload', uploadName], config);
    }
}

const loadingFile = (state, uploadName, idx) => {
    if (uploadName === ADITIONAL_EXPENSES_FILES) {
        let files = state.getIn(['upload', ADITIONAL_EXPENSES_FILES, 'files']);
        files = files.map(file => {
            if (file.get('idx') === idx) {
                return file.set('isFetching', true);
            } else {
                return file;
            }
        });

        return state.mergeDeep({
            upload: {
                isLoadingFiles: true,
                [uploadName]: {
                    files
                }
            }
        });

    } else {
        return state.mergeDeep({
            upload: {
                isLoadingFiles: true,
                [uploadName]: {
                    isFetching: true,
                    error: ''
                }
            }
        });
    }
}

const createFileObject = (documentType, valid) => (valid ? { name: getTranslatedDocumentName(documentType) } : {});

const loadFilesFromServer = (state, response) => {
    const { associatedDocuments, associatedReceipts } = response;

    const recordStatus = state.get('preApprovalState');
    const documentIrfp = find(associatedDocuments, document => document.documentType === IRPF100);
    const documentNominaCertificate = find(associatedDocuments, document => document.documentType === NOM_VL);

    const irfpIsPendingValidation = !!documentIrfp && documentIrfp.documentState === PEND_VAL;
    const certificateIsPendingValidation = !!documentNominaCertificate && documentNominaCertificate.documentState === PEND_VAL;

    const irfpIsNotValid = (recordStatus === ERROR_DOCUMENTACION)
        && !!documentIrfp
        && (documentIrfp.documentState === NO_VALIDO);
    const certificateIsNotValid = (recordStatus === ERROR_DOCUMENTACION)
        && !!documentNominaCertificate
        && (documentNominaCertificate.documentState === NO_VALIDO);

    let irfpLoaded;
    let nominaCertificateLoaded;
    let fileInfoIrfp;
    let fileInfoNominaCertificate;

    if (recordStatus === ERROR_DOCUMENTACION) {
        irfpLoaded = !irfpIsNotValid;
        nominaCertificateLoaded = !certificateIsNotValid;
        fileInfoIrfp = createFileObject(IRPF100, true);
        fileInfoNominaCertificate = createFileObject(NOM_VL, true);
    } else {
        irfpLoaded = irfpIsPendingValidation;
        nominaCertificateLoaded = certificateIsPendingValidation;
        fileInfoIrfp = createFileObject(IRPF100, irfpIsPendingValidation);
        fileInfoNominaCertificate = createFileObject(NOM_VL, certificateIsPendingValidation);
    }

    let files = [];

    if (associatedReceipts) {
        files = associatedReceipts.map((file, idx) => {
            const fileIsNotValid = (recordStatus === ERROR_DOCUMENTACION) && (file.documentState === NO_VALIDO);

            return Immutable.fromJS({
                isFetching: false,
                uploaded: true,
                loaded: true,
                error: '',
                notValid: fileIsNotValid,
                idx,
                documentId: file.documentReceiptId,
                newName: file.documentName,
                file: {
                    name: file.documentName
                }
            });
        });
    }

    const emptyConfig = {
        documentId: null,
        isFetching: false,
        loaded: false,
        error: '',
        uploaded: false,
        idx: files.length,
        newName: ''
    };

    if (files.length < MAX_UPLOAD_EXPENSES_COMPONENTS) {
        files = files.concat([Immutable.fromJS(emptyConfig)]);
    }

    return state.merge({
        upload: {
            isFetching: false,
            payrollLoanDocumentsState: response,
            [IRPF_FILE]: {
                isFetching: false,
                uploaded: irfpLoaded,
                loaded: irfpLoaded,
                error: '',
                notValid: irfpIsNotValid,
                file: fileInfoIrfp
            },
            [PAYROLL_LOAN_CERTIFICATE]: {
                isFetching: false,
                uploaded: nominaCertificateLoaded,
                loaded: nominaCertificateLoaded,
                error: '',
                notValid: certificateIsNotValid,
                file: fileInfoNominaCertificate
            },
            [ADITIONAL_EXPENSES_FILES]: {
                error: '',
                files
            }
        }
    });
}

const changeUploadConfig = (state, config, uploadName, idx, error = false, isLoadingFiles = false) => {
    if (uploadName === ADITIONAL_EXPENSES_FILES) {
        let files = state.getIn(['upload', ADITIONAL_EXPENSES_FILES, 'files']);
        if (!error) {
            if (files.size < MAX_UPLOAD_EXPENSES_COMPONENTS) {
                const changeFile = files.get(files.size - 1);
                const emptyConfig = {
                    documentId: null,
                    isFetching: false,
                    loaded: false,
                    error: '',
                    uploaded: false,
                    idx: changeFile.get('idx') + 1,
                    newName: ''
                };
                files = files.concat([Immutable.fromJS(emptyConfig)]);
            }
        }

        files = files.map(file => {
            if (file.get('idx') === idx) {
                return Immutable.fromJS(config);
            } else {
                return file;
            }
        });

        state = state.setIn(['upload', 'isLoadingFiles'], isLoadingFiles);
        state = state.setIn(['upload', uploadName, 'error'], '');
        state = state.setIn(['upload', uploadName, 'files'], files);
    } else {
        state = state.mergeDeep({
            upload: {
                isLoadingFiles,
                [uploadName]: config
            }
        });
    }
    return state;

}

const validateStep = (state, action) => {
    const currentStep = action.payload.currentStep;
    const isDragoFeature = action.payload.isDragoFeature;
    const newSteps = action.payload.newPersonalLoanFF;
    const stepIndex = currentStep - 1;
    const steps = newSteps ? 'newSteps' : 'steps'
    if (stepIndex === SECOND_STEP) {
        const setValues = {
            stepCallPreApproval: currentStep,
        }
        return validateStepTwo(state, setValues, isDragoFeature, newSteps);
    } else {
        const path = [steps, stepIndex, 'valid'];
        const partialState = state.setIn(path, true); // set step as valid.
        return partialState.merge({
            stepCallPreApproval: currentStep,
            visibleStep: currentStep + 1,
            checkboxFlag: currentStep === 4 && true
        });
    }
};

const editNameFile = (state, action) => {
    const idx = get(action, 'payload.response.idx');
    let files = state.getIn(['upload', ADITIONAL_EXPENSES_FILES, 'files']);
    files = files.map(file => {
        if (file.get('idx') === idx) {
            file = file.set('newName', get(action, 'payload.response.nameFile'));
            file = file.set('isFetching', false);
        }
        return file;
    });

    return state.mergeDeep({
        upload: {
            isLoadingFiles: false,
            [ADITIONAL_EXPENSES_FILES]: {
                files
            }
        }
    });
}

const setFileInvalidError = (state, idx) => {
    let files = state.getIn(['upload', ADITIONAL_EXPENSES_FILES, 'files']);

    files = files.map(file => {
        if (file.get('idx') === idx) {
            file = file.merge({
                error: true,
                isFetching: false,
                idx
            });
        }
        return file;
    });

    return state.mergeDeep({
        upload: {
            [ADITIONAL_EXPENSES_FILES]: {
                files
            }
        }
    });
}

const setErrorState = (state, action) => {
    const uploadName = get(action, 'payload.uploadName', '');
    const idx = get(action, 'payload.idx', FILE_FIRST_INDEX);
    const config = {
        isFetching: false,
        loaded: false,
        uploaded: false,
        error: get(action, 'payload.message', ''),
        idx
    };
    const error = true;

    if (uploadName === ADITIONAL_EXPENSES_FILES) {
        const immFiles = state.getIn(['upload', ADITIONAL_EXPENSES_FILES, 'files']);
        const immFile = immFiles.find(immFile => immFile.get('idx') === idx);
        if (immFile) {
            config.previousFileState = Object.assign({}, immFile.toJS());
        }
    }

    return changeUploadConfig(
        state,
        config,
        uploadName,
        idx,
        error
    );
}

const getNewJobTypesInformation = (state, action) => {
    const newJobTypesList = get(action, 'payload.response.data.jobType', []).map(newJobType => {
        return {
            value: newJobType.key,
            label: formatText(newJobType.keyPoeditor),
            jobLevel: newJobType.jobLevel,
        }
    });

    let employmentLevelList = [];
    if (!!state.get('newJobType')) {
        const employmentLevelElement = newJobTypesList.find(jobType => jobType.value === state.get('newJobType'));
        if (!!employmentLevelElement && employmentLevelElement.jobLevel) {
            employmentLevelList = employmentLevelElement.jobLevel.map(jobLevel => {
                if (jobLevel.visible) {
                    return {
                        value: jobLevel.key,
                        label: formatText(jobLevel.keyPoeditor),
                        contractType: jobLevel.contractType,
                    }
                }
            }).filter(Boolean)
        }
    }

    let contractTypeList = [];
    if (!!state.get('employmentLevel')) {
        const employmentLevel = employmentLevelList.find(employmentLevel => employmentLevel.value === state.get('employmentLevel'));
        employmentLevel.contractType = employmentLevel.contractType.filter(contractType => contractType.visible)
        if (!!employmentLevel && employmentLevel.contractType) {
            contractTypeList = employmentLevel.contractType
                .map(contractType => {
                    return {
                        value: contractType.key,
                        label: formatText(contractType.keyPoeditor),
                    }
                });
        }
    }

    return state.merge({
        isFetchingNewJobTypes: false,
        newJobTypesList,
        employmentLevelList,
        contractTypeList,
    });
}

const mapEmploymentLevelList = (state, action) => {
    const newJobTypesList = state.get('newJobTypesList');
    const newJobTypeValue = action.payload.jobType;

    const newJobType = newJobTypesList.find(newJobType => newJobTypeValue === newJobType.get('value'));
    let employmentLevelList = [];
    const thereIsValueVisible = newJobType.get('jobLevel').find(jobLevel => jobLevel.get('visible'));
    if (newJobType.get('jobLevel') && thereIsValueVisible) {
        employmentLevelList = newJobType.get('jobLevel').map(jobLevel => {
            if (jobLevel.get('visible')) {
                return {
                    value: jobLevel.get('key'),
                    label: formatText(jobLevel.get('keyPoeditor')),
                    contractType: jobLevel.get('contractType'),
                }
            }
        });
    }

    const showWorkingTime = showWorkingTimeSection(newJobTypeValue);
    const showTotalWorkingTime = state.get('newJobType') !== OWN_ACCOUNT_DRAGO_OPTION_KEY;

    const totalSenorityYears = showWorkingTime && showTotalWorkingTime ? state.get('totalSenorityYears') : null;
    const totalSenorityMonths = showWorkingTime && showTotalWorkingTime ? state.get('totalSenorityMonths') : null;
    const companyYears = showWorkingTime ? state.get('companyYears') : null;
    const companyMonths = showWorkingTime ? state.get('companyMonths') : null;

    return state.merge({
        newJobType: newJobTypeValue,
        employmentLevel: null,
        employmentLevelList,
        contractType: null,
        contractTypeList: [],
        totalSenorityYears,
        totalSenorityMonths,
        companyYears,
        companyMonths,
    });
}

const mapContractTypeList = (state, action) => {

    const employmentLevelList = state.get('employmentLevelList').toJS();
    const employmentLevelValue = action.payload.employmentLevel;

    const employmentLevel = employmentLevelList.find(employmentLevel => employmentLevelValue === employmentLevel.value);
    employmentLevel.contractType = Immutable.fromJS(employmentLevel.contractType)
    let contractTypeList = [];
    const thereIsValueVisible = employmentLevel.contractType.find(contractType => contractType.get('visible'));
    if (employmentLevel.contractType && thereIsValueVisible) {
        contractTypeList = employmentLevel.contractType.map(contractType => {
            if (contractType.get('visible')) {
                return {
                    value: contractType.get('key'),
                    label: formatText(contractType.get('keyPoeditor')),
                }
            }
        });
    }

    return state.merge({
        employmentLevel: employmentLevelValue,
        contractType: null,
        contractTypeList,
    });
}

const mapPersonalData = (state, action) => {
    const maritalStatus = get(action, 'payload.response.data.maritalStatus', []);
    const housingRegime = get(action, 'payload.response.data.housingRegime', []);

    const maritalStatusList = maritalStatus.map(maritalS => {
        return {
            value: maritalS.key,
            label: formatText(maritalS.keyPoeditor),
        }
    });
    const housingRegimeList = housingRegime.map(housingR => {
        return {
            value: housingR.key,
            label: formatText(housingR.keyPoeditor),
        }
    });

    return state.merge({
        isFetchingPersonalData: false,
        maritalStatusList,
        housingRegimeList,
    });
}

const getNewPurposes = (state, action) => {
    const newPurposesList = get(action, 'payload.response.data.categories', []).map(newPurpose => {
        return {
            id: newPurpose.key,
            text: formatText(newPurpose.keyPoeditor),
            icon: newPurpose.fontIcon,
            operationCode: newPurpose.key,
            subCategory: newPurpose.subCategory,
        }
    });

    let subpurposeList = [];
    const purposeElement = newPurposesList.find(purposeElement => purposeElement.id === state.get('selectedPurposeDrago'));
    if (!!purposeElement && purposeElement.subCategory) {
        subpurposeList = purposeElement.subCategory.map(subpurpose => {
            return {
                value: subpurpose.key,
                label: formatText(subpurpose.keyPoeditor),
            }
        });
    }

    return state.merge({
        isFetchingNewPurposes: false,
        newPurposesList,
        subpurposeList,
    });
}

const mapSubpurposeDrago = (state, action) => {
    const newPurposesList = state.get('newPurposesList');
    const { payload: { purpose, type, isDragoFeature } } = action;

    let subpurposeList = [];
    if (isDragoFeature) {
        const purposeElement = newPurposesList.find(purposeElement => purposeElement.get('id') === purpose);
        if (purposeElement.get('subCategory')) {
            subpurposeList = purposeElement.get('subCategory').map(immSubpurpose => {
                return {
                    value: immSubpurpose.get('key'),
                    label: formatText(immSubpurpose.get('keyPoeditor')),
                }
            });
        }
    }

    return state.merge({
        [type]: purpose,
        subpurposeList,
        subpurposeDrago: null,
    });
}

const payrollLoanRequestReducer = handleActions(
    {
        [simpleActions.payrollLoanRequestAmountKoxdti]: state =>
            state.set('isFetchingValidateAmountKOxDTI', true),
        [simpleActions.payrollLoanRequestAmountKoxdtiError]: state =>
            state.set('isFetchingValidateAmountKOxDTI', false),
        [simpleActions.payrollLoanRequestAmountKoxdtiSuccess]: (state, action) =>
            validateOfferKOxDTI(state, action),
        [simpleActions.payrollLoanRequestApproval]: state =>
            state.merge({
                error: false,
                isFetching: true,
                callServicePreApproval: false
            }),
        [simpleActions.payrollLoanRequestApprovalApproved]: (state, action) =>
            mapLoanApprovedInfo(state, action.payload.response),
        [simpleActions.payrollLoanRequestApprovalRejected]: state =>
            state.merge({
                isFetching: false,
                rejected: true
            }),
        [simpleActions.payrollLoanRequestApprovalLetter]: state =>
            state.merge({ isFetching: true, error: false }),
        [simpleActions.payrollLoanRequestApprovalLetterError]: state =>
            state.merge({ isFetching: false, error: true }),
        [simpleActions.payrollLoanRequestApprovalLetterSuccess]: (state, action) =>
            state.merge({
                pages: action.payload.response,
                isFetching: false,
                error: false
            }),
        [simpleActions.payrollLoanRequestProposition]: state =>
            state.mergeDeep({
                proposition: {
                    isFetching: true,
                    success: false
                }
            }),
        [simpleActions.payrollLoanRequestEditNameFileSuccess]: (state, action) =>
            editNameFile(state, action),
        [simpleActions.payrollLoanRequestPropositionError]: state =>
            state.mergeDeep({
                proposition: {
                    isFetching: false,
                    success: false
                }
            }),
        [simpleActions.payrollLoanRequestPropositionSuccess]: (state, action) =>
            processPropositionResponse(state, action.payload.response),
        [simpleActions.payrollLoanRequestInitialize]: (state) =>
            state.merge({
                error: false,
                isFetching: true,
                callServicePreApproval: true
            }),
        [simpleActions.payrollLoanRequestInitializeSuccess]: (state, action) =>
            state.mergeDeep(mapInitilialize(state, action.payload.response)),
        [simpleActions.payrollLoanRequestInitializeFlowSuccess]: (state, action) =>
            state.mergeDeep(mapInitilialize(state, action.payload.response, true)),
        [simpleActions.payrollLoanRequestInstallment]: (state) =>
            state.merge({ isFetchingInstallment: true }),
        [simpleActions.payrollLoanRequestInstallmentSuccess]: (state, action) =>
            state.mergeDeep(mapInstallment(action.payload.response)),
        [simpleActions.payrollLoanRequestMinTerm]: (state) =>
            state.set('isFetchingMinTerm', true),
        [simpleActions.payrollLoanRequestMinTermError]: (state) =>
            state.set('isFetchingMinTerm', false),
        [simpleActions.payrollLoanRequestMinTermSuccess]: (state, action) =>
            state.merge(mapMinTerm(action)),
        [simpleActions.payrollLoanRequestResetMinTermMaxAmount]: (state) =>
            state.merge({
                minTerm: MIN_TERM,
                maxAmount: MAX_AMOUNT
            }),
        [simpleActions.payrollLoanRequestReset]: (state) =>
            state.mergeDeep(setInitialState()),
        [simpleActions.payrollLoanRequestResetStep]: (state) =>
            state.merge({
                initialized: false,
                secondCallInitilized: true
            }),
        [simpleActions.payrollLoanRequestSaveInProgress]: (state) =>
            state.merge({
                callServicePreApproval: true,
                isCallingSaveInProgress: true
            }),
        [simpleActions.payrollLoanRequestSetWorkingTimeWrapper]: (state, action) =>
            state.merge({
                [action.payload.type]: (state.get(action.payload.type) || state.get(action.payload.type) === 0) ? `${state.get(action.payload.type)} ${action.payload.lastTypeOfTime}` : null,
            }),
        [simpleActions.payrollLoanRequestSetWorkingTimeWrapperFocus]: (state, action) =>
            state.merge({
                [action.payload.type]: state.get(action.payload.type) ? ((typeof state.get(action.payload.type) === "string") ? state.get(action.payload.type).split(' ')[0] : null) : null,
            }),
        [simpleActions.payrollLoanRequestSaveInProgressSuccess]: (state, action) => {
            return state.merge({
                isCallingSaveInProgress: false,
                changePayrollStatus: true,
                checkboxFlag: false,
                changeStatusINE: action.payload === false ? false : true,
                filePayrollLoanINEDocument: action.payload === false && false,
                agreeIneCheckbox: action.payload === false && false,
                scrollDown: action.payload === false && false,
                changeStatusSimpleEmail: true
            })
        },
        [simpleActions.payrollLoanRequestSetKoxdti]: (state) =>
            state.merge({ isFetchingKOxDTI: true }),
        [simpleActions.payrollLoanRequestSetKoxdtiSuccess]: (state, action) =>
            changeViewKOxDTI(state, action),
        [simpleActions.payrollLoanRequestSetAmount]: (state, action) =>
            state.set('selectedAmount', action.payload.selectedAmount),
        [simpleActions.payrollLoanRequestSetAmountKoxdti]: (state, action) =>
            state.mergeDeep({
                KOxDTI: {
                    seletedAmountOrTerm: true
                },
                selectedAmount: action.payload.selectedAmount,
                selectedTerm: MAX_TERM
            }),
        [simpleActions.payrollLoanRequestSetTerm]: (state, action) =>
            state.set('selectedTerm', action.payload.term),
        [simpleActions.payrollLoanRequestSetTermKoxdti]: (state, action) =>
            state.mergeDeep({
                KOxDTI: {
                    seletedAmountOrTerm: true
                },
                selectedTerm: get(action, 'payload.term', 0)
            }),
        [simpleActions.payrollLoanRequestSetPurpose]: (state, action) =>
            mapSubpurposeDrago(state, action),
        [simpleActions.payrollLoanRequestSetCivilStatus]: (state, action) =>
            state.merge({
                [action.payload.type]: action.payload.civilStatus,
            }),
        [simpleActions.payrollLoanRequestSetCollective]: (state, action) =>
            state.merge({ isCollective: true, collectiveName: action.payload.title }),
        [simpleActions.payrollLoanRequestSetCompanyMonths]: (state, action) =>
            state.merge({
                [action.payload.type]: action.payload.companyMonths,
            }),
        [simpleActions.payrollLoanRequestSetCompanyYears]: (state, action) =>
            state.merge({
                [action.payload.type]: action.payload.companyYears,
            }),
        [simpleActions.payrollLoanRequestSetCreditCard]: (state, action) =>
            state.set('creditCards', action.payload.creditCards),
        [simpleActions.payrollLoanRequestSetRegime]: (state, action) =>
            state.merge({
                [action.payload.type]: action.payload.regime,
            }),
        [simpleActions.payrollLoanRequestSetJob]: (state, action) =>
            processJob(state, action.payload.job),
        [simpleActions.payrollLoanRequestSetIncome]: (state, action) =>
            state.mergeDeep({ income: action.payload.income }),
        [simpleActions.payrollLoanRequestSetOutcome]: (state, action) =>
            state.mergeDeep({ outcome: action.payload.outcome }),
        [simpleActions.payrollLoanRequestSetVisibleStep]: (state, action) =>
            state.merge({
                stepCallPreApproval: state.get('visibleStep') - 1,
                visibleStep: action.payload.visibleStep
            }),
        [simpleActions.payrollLoanRequestValidateStep]: (state, action) =>
            validateStep(state, action),
        [simpleActions.payrollLoanRequestClearErrorsFile]: (state, action) =>
            clearErrors(
                state,
                action.payload.uploadName,
                action.payload.idx
            ),
        [combineActions(
            simpleActions.payrollLoanRequestUploadFileRemove,
            simpleActions.payrollLoanRequestUploadFile,
            simpleActions.payrollLoanRequestEditNameFile
        )]: (state, action) =>
                loadingFile(
                    state,
                    action.payload.uploadName,
                    action.payload.idx
                ),
        [simpleActions.payrollLoanRequestUploadFileDisable]: (state) =>
            state.set('enableDocumentsFlow', false),
        [combineActions(
            simpleActions.payrollLoanRequestUploadFileError,
            simpleActions.payrollLoanRequestEditNameFileError,
            simpleActions.payrollLoanRequestUploadFileRemoveError
        )]: (state, action) =>
                setErrorState(
                    state,
                    action
                ),
        [simpleActions.payrollLoanRequestUploadFileInvalidError]: (state, action) =>
            setFileInvalidError(
                state,
                get(action, 'payload.idx', FILE_FIRST_INDEX)
            ),
        [simpleActions.payrollLoanRequestUploadFileLoad]: (state, action) =>
            changeUploadConfig(
                state,
                {
                    isFetching: false,
                    error: '',
                    loaded: true,
                    uploaded: true,
                    idx: get(action, 'payload.response.idx', FILE_FIRST_INDEX),
                    documentId: get(action, 'payload.documentId', null),
                    newName: get(action, 'payload.newName', ''),
                    file: get(action, 'payload.response.file', '')
                },
                get(action, 'payload.response.uploadName', ''),
                get(action, 'payload.response.idx', FILE_FIRST_INDEX)
            ),
        [simpleActions.payrollLoanRequestUploadFileRemoveSuccess]: (state, action) =>
            removeFile(
                state,
                {
                    file: null,
                    isFetching: false,
                    loaded: false,
                    error: '',
                    uploaded: false,
                    newName: '',
                },
                get(action, 'payload.response.uploadName', ''),
                get(action, 'payload.response.idx', FILE_FIRST_INDEX)
            ),
        [simpleActions.payrollLoanRequestUploadStartConfirm]: state =>
            state.setIn(['upload', 'isFetchingDocumentsConfirm'], true),
        [simpleActions.payrollLoanRequestUploadFileReset]: (state) =>
            state.merge({ upload: setInitialState().get('upload') }),
        [simpleActions.payrollLoanRequestUploadFileSubmit]: (state) =>
            state.set('submitSuccessful', true),
        [simpleActions.payrollLoanRequestUploadFileSuccess]: (state, action) =>
            changeUploadConfig(
                state,
                { isFetching: false, uploaded: true },
                action.payload.uploadName
            ),
        [simpleActions.payrollLoanRequestGetLoansForExpenses]: state =>
            state.set('isFetchingLoans', true),
        [simpleActions.payrollLoanRequestGetLoansForExpensesError]: state =>
            state.merge({
                isFetchingLoans: false,
                error: true
            }),
        [simpleActions.payrollLoanRequestGetLoansForExpensesSuccess]: (state, action) =>
            state.merge({
                isFetchingLoans: false,
                loans: get(action, 'payload.response.loans', [])
            }),
        [simpleActions.payrollLoanRequestLoadFiles]: state =>
            state.mergeDeep({
                error: false,
                isFetching: true,
                callServicePreApproval: true,
                upload: {
                    isFetching: true
                }
            }),
        [simpleActions.payrollLoanRequestLoadFilesSuccess]: (state, action) =>
            loadFilesFromServer(
                state,
                get(action, 'payload.response')
            ),
        [simpleActions.payrollLoanRequestSentEmailPrecontractual]: state =>
            state.merge({
                isPrecontractualEmailIsFetiching: true,
                isPrecontractualEmailSent: false,
                isPrecontractualEmailError: false
            }),
        [simpleActions.payrollLoanRequestSentEmailPrecontractualError]: state =>
            state.merge({
                isPrecontractualEmailIsFetiching: false,
                isPrecontractualEmailSent: false,
                isPrecontractualEmailError: true
            }),
        [simpleActions.payrollLoanRequestSentEmailPrecontractualSuccess]: state =>
            state.merge({
                isPrecontractualEmailIsFetiching: false,
                isPrecontractualEmailSent: true,
                isPrecontractualEmailError: false
            }),
        [combineActions(
            simpleActions.payrollLoanRequestApprovalError,
            simpleActions.payrollLoanRequestInitializeError,
            simpleActions.payrollLoanRequestInstallmentError,
            simpleActions.payrollLoanRequestSaveInProgressError
        )]: (state, action) =>
                state.merge({
                    isFetchingInstallment: false,
                    isFetching: false,
                    error: true,
                    isCallingSaveInProgress: false,
                    errorCode: action.payload.errorCode,
                }),
        [simpleActions.payrollLoanRequestSetCirbeCheck]: state =>
            state.merge({
                checkboxCirbe: !state.get('checkboxCirbe'),
            }),
        [simpleActions.payrollLoanRequestResetCheckboxCirbe]: state =>
            state.merge({
                checkboxCirbe: false,
            }),
        [simpleActions.payrollLoanRequestGetJobs]: (state) =>
            state.set('isFetchingNewJobTypes', true),
        [simpleActions.payrollLoanRequestGetJobsError]: (state) =>
            state.set('isFetchingNewJobTypes', false),
        [simpleActions.payrollLoanRequestGetJobsSuccess]: (state, action) =>
            getNewJobTypesInformation(state, action),
        [simpleActions.payrollLoanRequestSetNewJobType]: (state, action) =>
            mapEmploymentLevelList(state, action),
        [simpleActions.payrollLoanRequestSetEmploymentLevel]: (state, action) =>
            mapContractTypeList(state, action),
        [simpleActions.payrollLoanRequestSetContractType]: (state, action) =>
            state.merge({
                contractType: action.payload.contractType,
            }),
        [simpleActions.payrollLoanRequestGetPurposes]: (state) =>
            state.set('isFetchingNewPurposes', true),
        [simpleActions.payrollLoanRequestGetPurposesError]: (state) =>
            state.set('isFetchingNewPurposes', false),
        [simpleActions.payrollLoanRequestGetPurposesSuccess]: (state, action) =>
            getNewPurposes(state, action),
        [simpleActions.payrollLoanRequestGetPersonalInfo]: (state) =>
            state.set('isFetchingPersonalData', true),
        [simpleActions.payrollLoanRequestGetPersonalInfoError]: (state) =>
            state.set('isFetchingPersonalData', false),
        [simpleActions.payrollLoanRequestGetPersonalInfoSuccess]: (state, action) =>
            mapPersonalData(state, action),
        [simpleActions.payrollLoanRequestSetSubpurpose]: (state, action) =>
            state.merge({
                subpurposeDrago: action.payload.subpurpose,
            }),
        [simpleActions.payrollLoanRequestSetTotalSenorityFieldsDirty]: (state, action) =>
            state.set('totalSenorityFieldsIsDirty', action.payload.status),
        [simpleActions.payrollLoanRequestSetSenorityFieldsDirty]: (state, action) =>
            state.set('senorityFieldsIsDirty', action.payload.status),
        [simpleActions.payrollLoanRequestDownloadPrecontractualIne]: state =>
            state.set('isFetchingPrecontractualDocuments', true),
        [combineActions(
            simpleActions.payrollLoanRequestDownloadPrecontractualIneError,
            simpleActions.payrollLoanRequestDownloadPrecontractualIneSuccess
        )]: state =>
                state.set('isFetchingPrecontractualDocuments', false),
        [combineActions(
            simpleActions.payrollLoanRequestDownloadIneError,
            simpleActions.payrollLoanRequestDownloadIneSuccess
        )]: (state) => state.set("isFetchingPrintDocuments", false),
        [simpleActions.payrollLoanRequestDownloadIne]: (state) =>
            state.set("isFetchingPrintDocuments", true),
        [simpleActions.payrollLoanRequestRecoveryProcessType]: (state) =>
            state.setIn(["processType"], "proc-simulation-loan-payroll recovery"),
        [simpleActions.payrollLoanInitIneSuccess]: (state, action) =>
            state.merge({
                payrollInitOperationProcessId: action.payload.payrollInitOperationProcessId,
                changeStatusINE: false
            }),
        [simpleActions.payrollLoanInitIneError]: (state) =>
            state.merge({
                error: true,
            }),
        [simpleActions.getPayrollLoanIneDocumentSuccess]: (state, action) => state.merge({
            filePayrollLoanINEDocument: `data:application/pdf;base64,${action.payload.base64}`,
            filePayrollLoanINEDocumentId: action.payload.documentId,
            filePayrollLoanINEDocumentSuccess: true
        }),
        [simpleActions.getPayrollLoanIneDocumentError]: (state, action) =>
            state.merge({
                error: true,
            }),
        [simpleActions.payrollLoanReadDocument]: (state, action) =>
            state.merge({
                scrollDown: true,
            }),
        [simpleActions.payrollLoanCheckBoxCheckedDocument]: (state, action) =>
            state.merge({
                agreeIneCheckbox: !action.payload,
                isFetchingDocuments: false
            }),
        [simpleActions.payrollLoanEmailSuccess]: (state, action) =>
            state.merge({
                isPayrollLoanEmailSent: true,
                isPayrollLoanEmailError: false,
                changeStatusSimpleEmail: false,
                isEasyLoanEmailSent: true,

            }),
        [simpleActions.payrollLoanEmailError]: (state, action) =>
            state.merge({
                isPayrollLoanEmailSent: false,
                isPayrollLoanEmailError: true
            }),
        [simpleActions.payrollLoanRequestAsnefError]: state =>
            state.merge({ error: true }),
        [simpleActions.payrollLoanRequestAsnefFailure]: state => {
            return state.merge({
                isFetchingAsnef: false,
                errorAsnef: true
            })
        },
        [simpleActions.payrollLoanRequestAsnef]: state =>
            state.merge({
                isFetchingAsnef: true,
                errorAsnef: false
            }),
        [simpleActions.getContractPayrollLoanExpedientIneSuccess]: state =>
            state.merge({
                expedientOperationProcessId: action.payload.operationProcessId,

            }),
        [simpleActions.getContractPayrollLoanExpedientIneSuccess]: state =>
            state.merge({
                expedientOperationProcessId: null,
            }),
        [simpleActions.payrollLoanRequestCheckRadioButton]: (state, action) => {
            return state.merge({
                payrollLoanRequestPrintedDocument: action.payload,
            })
        },
        [simpleActions.payrollLoanRequestPrintDocumentOffice]: state =>
            state.merge({
                payrollLoanRequestShowRadioButtons: true,
            }),
    },
    setInitialState()
);

module.exports = payrollLoanRequestReducer;
module.exports.setInitialState = setInitialState;
